module.exports = __webpack_public_path__ + "static/living-beautifully-67e774943795625a061d89089c497a5a.jpg";